import { useTranslation } from 'react-i18next';
import { Selo } from '../../componentes/base';
import { data, dinheiro, nomeCadastro, nomeParceiro } from '../../nucleo/formato';
import type { ResumoPreco } from './tipos';
import { anunciarOcultos } from '../../componentes/sensivel';

/**
 * Histórico de preço por produto e fornecedor (M10.4): último preço, média, menor e maior, com a data da última compra.
 * Quando o mesmo produto tem mais de um fornecedor, o de menor último preço ganha um selo.
 */
export function TabelaPrecos({ linhas, semFornecedor }: { linhas: ResumoPreco[]; semFornecedor?: boolean }) {
  const { t } = useTranslation('compras');
  if (linhas.length === 0) return <p className="text-sm text-tinta-3">{t('precos.vazio')}</p>;
  return (
    <div className="overflow-x-auto rounded-lg border border-borda">
      <table className="w-full text-sm">
        <thead>
          <tr className="border-b border-borda text-left text-tinta-3">
            <th scope="col" className="px-3 py-2 font-medium">
              {t('campos.produto')}
            </th>
            {!semFornecedor && (
              <th scope="col" className="px-3 py-2 font-medium">
                {t('campos.fornecedor')}
              </th>
            )}
            <th scope="col" className="px-3 py-2 text-right font-medium">
              {t('precos.compras')}
            </th>
            <th scope="col" className="px-3 py-2 text-right font-medium">
              {t('precos.ultimo')}
            </th>
            <th scope="col" className="px-3 py-2 text-right font-medium">
              {t('precos.media')}
            </th>
            <th scope="col" className="px-3 py-2 text-right font-medium">
              {t('precos.menor')}
            </th>
            <th scope="col" className="px-3 py-2 text-right font-medium">
              {t('precos.maior')}
            </th>
          </tr>
        </thead>
        <tbody>
          {linhas.map((l) => (
            <tr key={`${l.produto_id}-${l.fornecedor_id}`} className="border-b border-borda last:border-0">
              <td className="px-3 py-2">
                <span className="block max-w-56 truncate" title={l.produto_nome ?? undefined}>{nomeCadastro(l.produto_nome)}</span>
                <span className="numero block text-xs text-tinta-3">{l.produto_codigo}</span>
              </td>
              {!semFornecedor && (
                <td className="px-3 py-2">
                  <span className="flex flex-col items-start gap-1">
                    <span className="max-w-44 truncate" title={nomeParceiro(l.fornecedor_nome)}>{nomeParceiro(l.fornecedor_nome)}</span>
                    {l.menor_ultimo && <Selo cor="verde">{t('precos.maisBarato')}</Selo>}
                  </span>
                </td>
              )}
              <td className="numero px-3 py-2 text-right">{l.compras}</td>
              <td className="numero px-3 py-2 text-right">
                <span className="flex flex-col items-end">
                  <span className="font-medium">{anunciarOcultos(dinheiro(l.ultimo_centavos, l.moeda))}</span>
                  <span className="text-xs text-tinta-3">{data(l.ultima_data)}</span>
                </span>
              </td>
              <td className="numero px-3 py-2 text-right">{anunciarOcultos(dinheiro(l.media_centavos, l.moeda))}</td>
              <td className="numero px-3 py-2 text-right text-verde">{anunciarOcultos(dinheiro(l.menor_centavos, l.moeda))}</td>
              <td className="numero px-3 py-2 text-right">{anunciarOcultos(dinheiro(l.maior_centavos, l.moeda))}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
